<section class="section-shedule-app">
  <div class="img-shedule">
    <img src="{{ imagen_banner }}" />
  </div>
  <div class="container-shedule-app">
    <div class="header-shedule-app">
      <div class="icon-header-shedule">
        <i class="bi bi-calendar2-check"></i>
      </div>
      <div class="text-header-shedule">
        <h3>{{ "Schedule" | translate }}</h3>
        <p>{{ "YourDate" | translate }}</p>
      </div>
    </div>
    <form [formGroup]="ScheduleAppointmentForm">
      <div class="content-shedule">

        <div *ngIf="isLoading">
          <div class="overlay"></div>
          <section class="dialog-loading-container">
            <div class="uploader-status">
              <mat-spinner [diameter]="50"></mat-spinner>
            </div>
            <p class="dialog__loading-text">{{"LoadingDataMessage" | translate}}</p>
          </section>
        </div>

        <ng-container
        *ngIf="dercoBrand === 8">
          <h4 class="label-input-custom">{{ "SelectBrand" | translate }}</h4>
          <mat-form-field appearance="outline">
            <mat-select
              formControlName="brand"
              class="selectfomra"
              [(ngModel)]="indexbrand"
              name="brand"
            >
              <mat-option
                *ngFor="let brand of brands$ | async"
                [value]="brand.brandId"
                (click)="getCityDataFromService(brand.brandId)"
              >
                {{ brand.brandName }}
              </mat-option>

            </mat-select>
          </mat-form-field>
        </ng-container>

        <h4 class="label-input-custom">{{ "SelectYourCity" | translate }}</h4>
        <mat-form-field appearance="outline">
          <mat-select
            formControlName="ciudad"
            class="selectfomra"
            [(ngModel)]="city"
            name="city"
            formControlName="ciudad"
          >
            <mat-option
              *ngFor="let city of cities$ | async"
              [value]="city.cityId"
              (click)="filterCity(city.cityName)"
            >
              {{ city.cityName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div
          *ngIf="
            ciudadControl?.invalid &&
            (ciudadControl?.touched || ciudadControl?.dirty)
          "
        >
          <p class="error-ms" *ngIf="ciudadControl.errors?.['required']">
            {{ "ObligatoryField" | translate }}
          </p>
        </div>
      </div>
    </form>
    <div class="container-scheduling-cards">
      <h4 class="label-input-custom-blue">
        {{ "SelectYourAppointment" | translate }}
      </h4>
      <div class="content-cards">
        <button
          [disabled]="ScheduleAppointmentForm.invalid"
          class="cards-scheduling-workshop"
          [routerLink]="chooseServiceWorkshopUrl"
          [state]="{
            schedule: emptyschedule,
            brand: indexbrand,
            cityId: city,
            cityName: cityName,
            country: indexCountry,
            LanguageForCountry: recievedLanguageForCountry,
            utmParams:utmParams
          }"
        >
          <i class="bi bi-tools"></i>
          <div class="cards-text">
            <h3>{{ "ByWorkshop" | translate }}</h3>
            <p>
              {{ TextForWorkshopScheduleAppointments | translate }}
            </p>
          </div>
        </button>
        <!-- [disabled]="ScheduleAppointmentForm.invalid" -->
        <!-- <button
          [disabled]="ScheduleAppointmentForm.invalid"
          class="cards-scheduling-hour"
          [routerLink]="chooseServiceUrl"
          [state]="{
            schedule: emptyschedule,
            brand: indexbrand,
            cityId: city,
            cityName: cityName,
            country: indexCountry,
            LanguageForCountry: recievedLanguageForCountry
          }"
        >
          <i class="bi bi-clock-history"></i>
          <div class="cards-text">
            <h3>{{"ForHours"  | translate }}</h3>
            <p>{{"chosseAppoimentFoHours" | translate}}</p>
          </div>
        </button> -->
      </div>
    </div>
  </div>
</section>
